// extracted by mini-css-extract-plugin
export default {"cardContainer":"UserManagement_cardContainer__fJzVk","userManagement":"UserManagement_userManagement__9M+51","contentTitle":"UserManagement_contentTitle__xXvus"};